var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hamburger-button",class:{ isOpen: _vm.isOpen },attrs:{"role":"button","tabindex":"0"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"line line1"}),_vm._v(" "),_c('div',{staticClass:"line line2"}),_vm._v(" "),_c('div',{staticClass:"line line3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }